import * as React from "react";
import { useGlobal } from "kanopi-components/useGlobal";

import { CoverSectionsGrid } from "./CoverSectionsGrid";
import { InactiveCoverSection as StatelessInactiveCoverSection } from "./InactiveCoverSection";
import { useEditCoverSection } from "./useEditCoverSection";
import { CoverSectionModal } from "./CoverSectionModal";
import { useGlobalsContext } from "../Globals";
import { TOnMouseActionFunc } from "kw/types";

type TInactiveCoverSectionsProps = {
  coverSections: TCoverSection[];
  prefix: string;
  riskProfile: TRiskProfile;
  disabled?: boolean;
  policyId: string;
};

export const InactiveCoverSections: React.FC<TInactiveCoverSectionsProps> = ({
  coverSections = [],
  prefix,
  riskProfile,
  disabled,
  policyId,
  ...props
}) => {
  const [updatingCoverSection, setUpdatingCoverSection] =
    React.useState<TCoverSection>();

  const { startEditing } = useEditCoverSection({
    coverSection: updatingCoverSection,
    prefix,
  });
  const makeHandleEdit = (cover: TCoverSection) => () => {
    setUpdatingCoverSection(cover);
  };
  React.useEffect(() => {
    if (updatingCoverSection) {
      startEditing();
    }
  }, [updatingCoverSection]);

  return (
    <CoverSectionsGrid columns={2} data-testid="inactiveCoverSections">
      {coverSections.map((coverSection) => (
        <InactiveCoverSection
          key={coverSection.id}
          prefix={prefix}
          coverSection={coverSection}
          riskProfileId={riskProfile.id}
          riskData={riskProfile?.riskData}
          edit={makeHandleEdit(coverSection)}
          disabled={disabled}
          {...props}
        />
      ))}
      <CoverSectionModal
        coverSection={updatingCoverSection}
        riskProfileId={riskProfile.id}
        prefix={prefix}
        policyId={policyId}
        title={updatingCoverSection?.title}
        description={updatingCoverSection?.description}
        onClose={() => setUpdatingCoverSection(undefined)}
      />
    </CoverSectionsGrid>
  );
};

type TProps = {
  coverSection?: TCoverSection;
  prefix: string;
  riskProfileId: TRiskProfile;
  riskData: TRiskData;
  disabled: boolean;
  edit: TOnMouseActionFunc;
};

// NOTE: Not sure if this naming is appropriate?
const InactiveCoverSection: React.FC<TProps> = ({
  coverSection = {},
  prefix,
  riskProfileId,
  riskData,
  disabled,
  edit,
}) => {
  const globalsContext = useGlobalsContext();
  const [data] = useGlobal(globalsContext);
  const coverSectionWithIcon =
    !coverSection?.icon && coverSection?.parentCover?.icon
      ? { ...coverSection, icon: coverSection?.parentCover?.icon }
      : coverSection;

  return (
    <StatelessInactiveCoverSection
      coverSection={coverSectionWithIcon}
      riskProfileId={riskProfileId}
      riskData={riskData}
      edit={edit}
      disabled={disabled || data?.reprice}
      prefix={prefix}
    />
  );
};

export { InactiveCoverSection };
